import { useQuery } from 'react-query';
import { QueryResponse } from '@/modules/queryfilter/domain/interfaces';

export function useOptionsQuery(queryKey: string[]) {
  const query = useQuery<QueryResponse<Option>>(queryKey);

  return query;
}
